<!--
 * @Descripttion: 育儿音频详情
 * @Author:xionggang
-->
<template>
  <div class="audio-box">
    <!-- 小程序环境隐藏返回导航 -->
    <Back v-if="!checkFromMiniprogram" @goBack="goBack">
      <div slot="header">
        <div class="back" @click.stop="goBack">
          <van-icon name="arrow-left" size="20"/>
        </div>
      </div>
    </Back>
    <!-- 头部 -->
    <div class="audio-img">
      <img :src="audioInfo.coverUrl" alt />
    </div>
    <!-- 标题 -->
    <div class="audio-title">
      <span>{{ getCaption(audioInfo) }}</span>
    </div>
    <!-- 音频进度条 -->
    <audio-slider
        ref="audio"
        :audioInfo="audioInfo"
        :audioSlide="audioSlide"
        :isDisbled="isDisbled"
        :pages="pages"
        :playDisbled="playDisbled"
        @listenLogin="listenLogin"
        @playSensor="playSensor"
        @sendNextPlay="getNextPlayId"
        @sendPrevPlay="getPrevPlayId"
    ></audio-slider>

    <!-- 小程序环境隐藏点赞/收藏/分享/评论输入框 -->
    <comment-field v-if="!checkFromMiniprogram" ref="focus" :articalId="audioInfo.id" :carrierId="carrierId" :isGoLogin="isGoLogin"
                   :title="audioInfo.name || audioInfo.title" @isLogin="globalGoLogin">
      <!-- 点赞模块 -->
      <template slot="audio">
        <span class="commentShare" @click.stop="onLike(audioInfo)">
          <div>
            <img
                :src="
                !audioInfo.orLike
                  ? require('../../../assets/images/icon/like_.png')
                  : require('../../../assets/images/icon/like2.png')
              "
            />
            <span class="num">{{ fomatterNum(audioInfo.likeNum) }}</span>
          </div>
        </span>
        <!-- 收藏 -->
        <span class="commentShare share3" @click.stop="onCllect(audioInfo)">
          <div>
            <img
                :src="
                !audioInfo.orFavorites
                  ? require('../../../assets/images/icon/praise_.png')
                  : require('../../../assets/images/baby/icon2.png')
              "
                alt
                class="share2 collect-shareshare"
            />
            <span class="num">{{ fomatterNum(audioInfo.collectNum) }}</span>
          </div>
        </span>
        <!-- 分享 -->
        <span class="commentShare share2" @click.stop="shareLink(audioInfo)">
          <div>
            <img alt class="share1" src="@/assets/images/icon/share_.png"/>
          </div>
        </span>
      </template>
    </comment-field>
    <!-- 小程序环境隐藏评论列表/分享弹窗/登录引导/返回星妈会 -->
    <template v-if="!checkFromMiniprogram">
      <all-comment
       :isGoLogin="isGoLogin"
        @toReplyCom="toReplyCom"
        :carrierId="carrierId"
        @focusOn="getFocusOn"
        @type="getType"
        ref="allComment"
        :articalId="audioInfo.id"
        :title="audioInfo.name"
      ></all-comment>
      <audioShare ref="share"></audioShare>
      <login-tip
          :show="checkLogin"
          @cancleWay="cancleWay"
          @confirmWay="confirmWay"
      ></login-tip>
      <back-xmh v-if="showShareCagechild" @goHomeTap="goHomeTap"></back-xmh>
    </template>
  </div>
</template>
<script>
import {
  Debounce,
  fomatterNum,
  getCookie,
  getHeadImgAndName,
  globalGoLogin,
  isFromMiniprogram,
  is_weixin,
  isUserLogin,
  MakeDurationToSeconds,
  setCookie
} from "@/assets/js/common.js"; //工具类
import Back from "@/components/common/goBack";
import API_ from "@/utils/axiosApi/audioApi.js"; //api育儿音频事件
//进度播放组件
import audioSlider from "@/components/contents/parentingAudio/audioSlider";
// 输入框组件
import commentField from "@/components/comment/commentField.vue";
//评论组件
import allComment from "@/components/comment/allComment.vue";
//分享弹窗
import audioShare from "@/components/comment/share.vue";
import loginTip from "./component/logintip";
import backXmh from "../cageChild/component/backxmh"; //返回星妈会图标组件
import RequestApi from "./common.js";

export default {
  name: "audiodetail",
  components: {
    audioSlider,
    commentField,
    allComment,
    Back,
    audioShare,
    loginTip,
    backXmh
  },
  data() {
    return {
      audioSlide: false,
      playId: null, //当前播放id
      checkLogin: false,
      collectShow: false,
      fomatterNum: fomatterNum,
      ABtest: "",
      cllectState: false,
      likeState: false,
      // carrierId传值为5为音频
      carrierId: "5",
      //音频列表
      audioList: [],
      //音频数据总数
      total: 0,
      //音频详情
      audioInfo: {},
      // 分页参数
      pages: {
        page: 1,
        size: 25,
      },
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      type: "",
    };
  },
  watch: {
    type: function (newVal, oldVal) {
      console.log(newVal);
      if (newVal === "cagechild" || newVal === "doctorHome") {
        this.carrierId = "6";
      } else {
        this.carrierId = "5";
      }
    },
  },
  computed: {
    isGoLogin() {
      return isUserLogin()
    },
    // 判断是否来自小程序环境
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route);
    },
    showShareCagechild() {
      return this.$route.query.share === "cagechild";
    },
    playDisbled() {
      return this.$route.query.disabled === "disabled";
    },
    isDisbled() {
      return this.audioList.length == 1;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const routeParam = vm.$route.query.type; //获取路由参数
      if (routeParam == "cagechild" || routeParam == "doctorHome") {
        document.title = "凯淇育儿详情";
      } else {
        document.title = "育儿音频详情";
      }

      if (vm.is_weixin()) {
        if (
            vm.getCookie("xmh_openid") == null ||
            vm.getCookie("xmh_openid") == ""
        ) {
          if (routeParam === "cagechild" || routeParam === "doctorHome" || routeParam === "audio") {
            vm.audioSlide = true;
            vm.initPage();
          } else {
            //判断有没有openId
            location.href =
                "/xmh/v2/wechat/oauth2/authorize?url=" +
                encodeURIComponent(window.location.href);
          }
        } else {
          vm.userInfo = JSON.parse(localStorage.getItem("userInfo"));
          if (
              vm.userInfo == null ||
              vm.userInfo == "" ||
              vm.userInfo.mobile == null ||
              vm.userInfo.mobile == "" ||
              vm.userInfo.mobile == "null"
          ) {
            //没有手机号未注册
            vm.wxJsSet.getUserInfoBywx(
                vm,
                function () {
                  vm.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                  if (
                      vm.userInfo.mobile == null ||
                      vm.userInfo.mobile == "" ||
                      vm.userInfo.mobile == "null"
                  ) {
                    if (
                        routeParam === "cagechild" ||
                        routeParam === "doctorHome" ||
                        routeParam === "audio"
                    ) {
                      vm.audioSlide = true;
                      vm.initPage();
                    } else {
                      //没有手机号未注册
                      globalGoLogin()
                    }
                  } else {
                    vm.initPage();
                  }
                },
                function () {
                  if (routeParam === "cagechild" || routeParam === "doctorHome" || routeParam === "audio") {
                    vm.audioSlide = true;
                    vm.initPage();
                  } else {
                    //没有手机号未注册
                    globalGoLogin()
                  }
                }
            );
          } else {
            vm.initPage();
          }
        }
      } else {
        vm.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (
            vm.getCookie("xmh_phone") == null ||
            vm.getCookie("xmh_phone") == "" ||
            vm.userInfo == null ||
            vm.userInfo == ""
        ) {
          //未登录
          if (routeParam == "cagechild" || routeParam == "kq" || routeParam === "audio") {
            vm.initPage();
          } else {
            //没有手机号未注册
            globalGoLogin()
          }
        } else {
          vm.initPage();
        }
      }
    });
  },

  mounted() {
  },

  methods: {
    isUserLogin,
    getCookie,
    setCookie,
    is_weixin,
    globalGoLogin,
    goHomeTap() {
      this.goHomeSensor("点击");
      this.$router.push({
        path: "/home",
      });
    },
    playSensor(name) {
      this.playsenor(name)
    },
    goHomeSensor(msg) {
      sensors.track("buoy", {
        button_name: msg,
      });
    },
    isLength() {
      this.isDisabled = true;
    },
    getCaption(val) {
      if (Object.keys(val).length > 0) {
        if (val.name.indexOf("mp3") == -1) {
          return val.name;
        } else {
          return val.title;
        }
      }
    },
    palyNumResponse(type, id, fn) {
      let o = {
        id: id,
      };
      if (type == "cagechild" || type == "doctorHome") {
        RequestApi.addPlayAPI[type](o, (res) => {
          fn(res);
        });
      } else {
        RequestApi.addPlayAPI[type]({}, o, (res) => {
          fn(res);
        });
      }
    },
    //增加播放量
    addPalyNum(id) {

      if (this.playId == id) return;
      this.palyNumResponse(this.type, id, (res) => {
        if (res.code == 200) {
          this.playId = id;
        } else {
          this.$toast("网络异常");
        }
      });


    },
    columnTest() {
      let senorCage = ["doctorHome", "cagechild", "newAudio"];
      let senorye = ["collect", "search", "audio"];
      if (senorCage.includes(this.type)) {
        return '凯淇育儿'
      }
      if (senorye.includes(this.type)) {
        return '育儿音频'
      }
    },
    // 播放埋点
    playsenor(name) {
      // const { audioTime } = this.$store.state.recordAudio;
      let senorCage = ["doctorHome", "cagechild", "newAudio"];
      let senorye = ["collect", "search", "audio"];
      let total = MakeDurationToSeconds(this.audioInfo.durationStr);
      let audioTime = MakeDurationToSeconds(this.$refs.audio.timeRange.start);
      let num = audioTime / total;
      let time=this.audioInfo.durationStr.split(":")[0]*60+this.audioInfo.durationStr.split(":")[1]*1-1
      if (senorCage.includes(this.type)) {
        sensors.track("Audio_and_video_playback", {
          content_id: this.audioInfo.id,
          content_title: this.audioInfo.name,
          length_of_time: time,
          content_topic: this.audioInfo.audioClassify ? this.audioInfo.audioClassify : '',
          position: 0,
          video_duration: String(audioTime),
          is_finished: num >= 0.8 ? true : false,
          Content_column: this.type === "cagechild" ? "凯淇育儿" : "",
          doctor: this.audioInfo.authorName ? this.audioInfo.authorName : '',
          Playback_status: name
        });
      }
      if (senorye.includes(this.type)) {
        sensors.track("Audio_and_video_playback", {
          content_id: String(this.audioInfo.id),
          content_title: this.audioInfo.title,
          length_of_time: time,
          content_topic: "",
          position: 0,
          video_duration: Number(audioTime),
          is_finished: num >= 0.8 ? true : false,
          Shopping_guide_ID: "",
          account_type: "",
          Content_column: '育儿音频'
        });
      }
    },
    // 未登录10s
    listenLogin() {
      if (
          isUserLogin() &&
          (RequestApi.getParams("type") === "cagechild" ||
              RequestApi.getParams("type") === "doctorHome")
      ) {
        this.$refs.audio.startPlayer();
        this.checkLogin = true;
      }
    },
    confirmWay() {
      this.checkLogin = false;
      globalGoLogin()
      this.$refs.audio.$refs.audio.pause()
      // 未注册用户弹窗确定埋点
      this.loginRegistSensors("确定");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: '凯淇育儿'
      });
    },
    cancleWay() {
      this.checkLogin = false;
      // 未注册用户弹窗取消埋点
      this.loginRegistSensors("取消");
      this.$refs.audio.setAudioTime();

      // this.$refs.audio.startPlayer()
    },
    //初始化函数
    initPage() {
      this.type = RequestApi.getParams("type");
      if (
          this.$route.query.expertId == "kq" &&
          this.$route.query.expertId != undefined
      ) {
        this.type = "cagechild";
        this.carrierId = "6";
      }
      if (RequestApi.getParams("type") === "search") {
        this.$store.commit("saveAuidoTime", {
          id: "",
          time: 0,
          page: "",
        });
      }
      if (this.$route.query.isKq == "kq") {
        this.type = "cagechild";
        this.carrierId = "6";
      }

      sessionStorage.setItem("currentPlayStatus", "1");
      let _id = this.$route.query.id;
      let type = this.$route.query.type;

      // 获取上一个页面记录的分页
      let {id} = this.$store.state.recordAudio;
      if (type == "message") {
        this.pages.page = 1;
        this.initDetail(_id);
      } else {
        if (id) {
          let {page, id} = JSON.parse(sessionStorage.getItem("recordAudio"));
          this.pages.page = page;
          this.initDetail(id);
        } else {
          this.pages.page = 1;
          this.initDetail(_id);
        }
      }
      this.getAllAudio();

      this.getUserName();
    },
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie("xmh_headimgurl", headImgurl, 365);
        this.setCookie("xmh_nickname", nickName, 365);
      } catch (err) {

      }
    },
    toReplyCom(item) {
      this.$store.commit("saveAuidoTime",{
        page: this.$store.state.page,
        id: item.carrierSpecificId,
        audioTime: this.$refs.audio.$refs.audio.currentTime,
      });
    },
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool;
    },
    getType(type) {
      this.$refs.focus.type = type;
    },
    // 返回上一页
    goBack() {
      const backRoute = new Map([
        ["cagechild", "/cagechild"],
        ["audio", "/calendar?shareFrom=audio"],
        ["search", "/search/aprentAudio"],
        ["doctorHome", "/cagechild"],
      ]);
      const routeParam = RequestApi.getParams("type"); //获取路由参数
      if (window.history.length > 1 && getCookie("fromPath")) {
        this.$router.back(-1);
      } else {
        this.$router.push({
          path: backRoute.get(routeParam) || backRoute.get("audio"),
        });
      }
    },
    /**
     * @description: 上一个视频
     * @param {id} 音频id
     * @return {*}
     */

    getPrevPlayId(id) {
      var _index = 0;
      this.audioList.findIndex((res, index) => {
        if (res.id == id) {
          _index = index;
        }
      });
      _index === 0 ? this.PrevPlayWay() : _index--;
      if (_index >= 0) {
        if (
          this.audioList[_index]?.collectType == "kq" ||
          this.audioList[_index].audio_type == "kq"
        ) {
          this.type = "cagechild";
        }
      }

      this.initDetail(this.audioList[_index].id);
    },

    PrevPlayWay() {
      if (this.pages.page === 1) {
        this.pages.page = Math.ceil(this.total / this.pages.size);
      } else {
        this.pages.page--;
      }
      this.getAllAudio("prev");
    },
    /**
     * @description: 下一个视频
     * @param {id} 音频id
     * @return {*}
     */

    getNextPlayId(id) {
      if (this.playDisbled || this.isDisbled) {
        this.audioInfo = {};
        this.initDetail(id);
        return;
      }

      // let _index = this.audioList.findIndex((res) => res.id === id);
      var _index = 0;
      this.audioList.findIndex((res, index) => {
        if (res.id == id) {
          _index = index;
        }
      });
      _index === this.audioList.length - 1 ? this.NextPlayWay() : _index++;
      console.log(this.audioList[_index]);
      // if (_index != this.audioList.length - 1) {
      if (
        this.audioList[_index]?.collectType == "ye" ||
        this.audioList[_index].audio_type == "ye"
      ) {
        this.type = "collect";
      } else if (
        this.audioList[_index]?.collectType == "kq" ||
        this.audioList[_index].audio_type == "kq"
      ) {
        this.type = "cagechild";
      }
      // }

      this.initDetail(this.audioList[_index].id);
    },
    NextPlayWay() {
      if (this.audioList.length < this.pages.size) {
        this.pages.page = 1;
        this.getAllAudio("init");
      } else {
        this.pages.page++;
        this.getAllAudio("next");
      }
    },

    /**
     * @description: 初始化详情
     * @param {id} 音频id
     * @return {*}
     */

    initDetail(id) {
      let _this = this;
      //判断sign过来 1 最新音频 0列表音频
      if (RequestApi.getParams("sign") == 1) {
        this.type = "newAudio";
      }
      RequestApi.eventAPI[this.type](
        {},
        { id: id, crmId: this.userInfo ? this.userInfo.crm_id : "" },
        (res) => {
          if (res.code === 200) {
            if (this.type == "doctorHome" || this.type == "cagechild") {
              res.data.isKq = "kq";
            }
            //是最新音频的话直接加入字段only
            if (this.type === "newAudio") {
              res.data.only = "only";
            }
            res.data.audioAddress = res.data.audioAddress || res.data.contentUrl;
            this.audioInfo = res.data;
            // this.$nextTick(()=>{
            //     this.$refs.audio.autoplayAudio()
            // })
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            let param = window.location.href.split("?")[1];

              let goPath = this.$http.hostName + "/calendar/audiodetail?" + param;

            // var link =
            //   this.$http.hostName + "/calendar/audiodetail?type=audio&id=" + id;
            var shareDataParams = {
              shareLink: goPath,
              shareDesc: this.carrierId == "5"?"每天一个故事，用爱养育宝宝，用心陪伴孩子": "每天一点育儿小知识，陪你从新妈变星妈！",
              shareTitle: this.carrierId == '6' ? res.data.name :res.data.title,
              imgUrl: res.data.coverUrl, //必须是绝对路径
              shareid: res.data.id,
              shareFlag: true,
              shareType: "audio",
            };
            console.log(shareDataParams)

              _this.wxJsSet.wxShare("fx", shareDataParams, _this);
              _this.addPalyNum(id);
            }
          }
      );
    },
    // 获取所有视频 model为next 下一个音频请求 prev上一个音频请求
    getAllAudio(model = "") {
      var {tagAgeId = "", tagClassId = "", expertId = "", doctorId = ""} = this.$route.query;
      if (this.playDisbled || this.isDisbled) return;
      if (expertId == "kq" || expertId == "ye") {
        expertId = "";
      }
      var all = {
        crmId: this.userInfo ? this.userInfo.crm_id : "",
        ...this.pages,
        tagAgeId: tagAgeId,
        tagClassId: tagClassId,
        expertId: RequestApi.getParams("type") == "collect" ? "" : RequestApi.getParams("type") == "doctorHome" ? doctorId : expertId,
      };
      var type = {};
      if (RequestApi.getParams("type") == "search") {
        all = JSON.parse(this.$route.query.data);

        type = "audioSearch";
      }
      RequestApi.listAPI[
        RequestApi.getParams("sign") == 1
          ? "newAudio"
          : RequestApi.getParams("type")
      ](type, all, (res) => {
        if (res.code === 200) {
          const { data, total } =
            this.type == "doctorHome" ? res.data.listKqAudio : res.data;
            this.audioList = data;
          this.audioList.forEach((item, index) => {
            item.id = item.id;
            item.orPlay = false;
          });
          this.total = total;
          this.matchAudio(model)();
        }
      });
    },
    matchAudio(status) {
      const actions = new Map([
        [
          "prev",
          () => {
            if (
              this.audioList[this.audioList.length - 1].audio_type == "ye" ||
              this.audioList[this.audioList.length - 1]?.collectType == "ye"
            ) {
              this.type = "search";
            } else if (
              this.audioList[this.audioList.length - 1].audio_type == "kq" ||
              this.audioList[this.audioList.length - 1]?.collectType == "kq"
            ) {
              this.type = "cagechild";
            }
            this.initDetail(this.audioList[this.audioList.length - 1].id);
          },
        ],
        [
          "next",
          () => {
            if (
              this.audioList[0].audio_type == "ye" ||
              this.audioList[0]?.collectType == "ye"
            ) {
              this.type = "search";
            } else if (
              this.audioList[0].audio_type == "kq" ||
              this.audioList[0]?.collectType == "kq"
            ) {
              this.type = "cagechild";
            }

            this.initDetail(this.audioList[0].id);
          },
        ],
        [
          "init",
          () => {
            if (
              this.audioList[0].audio_type == "ye" ||
              this.audioList[0]?.collectType == "ye"
            ) {
              this.type = "search";
            } else if (
              this.audioList[0].audio_type == "kq" ||
              this.audioList[0]?.collectType == "kq"
            ) {
              this.type = "cagechild";
            }
            this.initDetail(this.audioList[0].id);
          },
        ],

        ["default", () => {
        }],
      ]);
      return actions.get(status) || actions.get("default");
    },
    likeResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };

      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        RequestApi.LikeAPI[type](o, (res) => {
          fn(res);
        });
      } else {
        RequestApi.LikeAPI[type]({}, o, (res) => {
          fn(res);
        });
      }
    },
    // 点赞
    onLike: Debounce(function (item) {
      if (item.orLike) {
        this.cancelLike(item);
      } else {
        if (this.isUserLogin()) {
          globalGoLogin()
        } else {
          this.likeResponse(this.type, item, (res) => {
            if (res.code == 200) {
              this.audioInfo.orLike = true;
              this.audioInfo.likeNum++;
              this.$toast({
                duration: 2000,
                message: "点赞成功",
                context: this,
              });
            } else {
              this.$toast("网络异常");
            }
          });

          sensors.track("Support", {
            content_id: item.id,
            content_title: item.name || item.title,
            Column: this.columnTest(),
            Poster_Date: "",
            // A_B_flow: this.ABtest,
          });
        }
      }
    }, 100),
    onCllectResponse(type, item, fn) {
      console.log(type);
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        RequestApi.collectAPI[type](o, (res) => {
          fn(res);
        });
      } else {
        RequestApi.collectAPI[type]({}, o, (res) => {
          fn(res);
        });
      }
    },
    //收藏
    onCllect: Debounce(function (item) {
      console.log(item);
      if (item.orFavorites) {
        this.cancelCllect(item);
      } else {
        if (this.isUserLogin()) {
          globalGoLogin()
        } else {
          this.onCllectResponse(this.type, item, (res) => {
            if (res.code == 200) {
              this.audioInfo.collectNum++;
              this.audioInfo.orFavorites = true;
              this.$toast({
                duration: 2000,
                message: "收藏成功",
                context: this,
              });
            } else {
              this.$toast("网络异常");
            }
          });

          sensors.track("Save", {
            content_id: item.id,
            content_title: item.name,
            Column: this.columnTest(),
            Poster_Date: "",
            // A_B_flow: this.ABtest,
          });
        }
      }
    }, 100),
    cancelCllectResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (
          this.type == "cagechild" ||
          this.type == "doctorHome" ||
          type == "newAudio"
      ) {
        RequestApi.canclecollectAPI[this.type](o, (res) => {
          fn(res);
        });
      } else {
        RequestApi.canclecollectAPI[this.type]({}, o, (res) => {
          fn(res);
        });
      }
    },
    // 取消收藏
    cancelCllect: Debounce(function (item) {
      if (this.isUserLogin()) {
        globalGoLogin()
      } else {
        this.cancelCllectResponse(this.type, item, (res) => {
          if (res.code == 200) {
            this.audioInfo.collectNum--;
            this.audioInfo.orFavorites = false;
          } else {
            this.$toast("网络异常");
          }
        });

        sensors.track("CancelSave", {
          content_id: item.id,
          content_title: item.name,
          Column: this.columnTest(),
          Poster_Date: "",
          //   A_B_flow: this.ABtest,
        });
      }
    }, 100),
    //分享
    shareLink: Debounce(function (item) {
      this.$refs.share.showShareVideo();
      API_.shareLink({}, {id: item.id}, (res) => {
        if (res.code == 200) {
          setTimeout(() => {
            if (this.audioInfo.orShare) {
              this.audioInfo.shareNum++;
            }
            this.audioInfo.orShare = true;
          }, 500);
        } else {
          this.$toast("网络异常");
        }
      });
      sensors.track("Share", {
        content_id: item.id,
        content_title: item.audioName,
        Column: this.columnTest(),
        Poster_Date: "",
        // A_B_flow: this.ABtest,
      });
    }, 100),
    canclelikeResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        RequestApi.cancleLikeAPI[type](o, (res) => {
          fn(res);
        });
      } else {
        RequestApi.cancleLikeAPI[type]({}, o, (res) => {
          fn(res);
        });
      }
    },
    //取消点赞
    cancelLike: Debounce(function (item) {
      if (this.isUserLogin()) {
        globalGoLogin()
      } else {
        this.canclelikeResponse(this.type, item, (res) => {
          if (res.code == 200) {
            this.audioInfo.orLike = false;

            this.audioInfo.likeNum > 0 && this.audioInfo.likeNum--;
          } else {
            this.$toast("网络异常");
          }
          sensors.track("Unsupport", {
            content_id: item.id,
            content_title: item.name || item.title,
            Column: this.columnTest(),
            Poster_Date: "",
            //   A_B_flow: this.ABtest,
          });
        });
      }
    }, 100),
  },
};
</script>
<style lang="less" scoped>
html,
body {
  .audio-box {
    overflow-x: hidden;
    background: #fff;
    min-height: 100vh;
    height: auto;

    .back {
      position: relative;
      top: 10px;
      left: 6px;
    }

    .audio-img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      padding: 20px 0;

      img {
        width: 100%;
        height: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 8px;
      }
    }

    .audio-title {
      padding: 0 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 16px;
      text-align: center;

      span {
        text-align: justify;
        display: inline-block;
      }
    }

    .commentShare {
      // flex: 1;
      display: flex;
      margin-right: 5px;
      justify-content: center;
      align-items: center;

      div {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 14px !important;
          height: 14px !important;
          vertical-align: middle;
        }

        .van-icon {
          font-size: 20px;
          vertical-align: middle;
        }

        .num {
          padding-left: 5px;
          font-size: 12px;
          color: #999;
          vertical-align: middle;
        }

        .collect-shareshare {
          padding-bottom: 2px;
        }
      }
    }
  }
}
</style>
